import React from 'react';
import { useTranslate } from '../../mixins/translate/translate';
import { openApiFetchDelete, openApiFetchGet } from '../../store/openApiFetch';
import { IconRemoveButton } from '../common/iconButtons/IconRemoveButton';
import {
    Content,
    Panel,
    PanelTable,
    TableBody,
    TableData,
    TableHead,
    TableHeader,
    TableHeadRow,
    TableRow,
    TopbarCrumbActive,
    TopbarLeftOnly,
    Tray,
} from '../elements';
import { Spinner } from '../spinners';
import { useReactAsync } from '../utils/useReactAsync';

async function loadRunningJobs() {
    const result = await openApiFetchGet('/api/workers/admin/jobs', {});
    return result;
}

export function Jobs() {
    const translate = useTranslate();
    const { data, reload, isLoading } = useReactAsync(loadRunningJobs, {}, []);

    async function removeJob(jobId: string) {
        await openApiFetchDelete('/api/workers/jobs/{jobId}', { jobId });
        await reload();
    }

    return (
        <>
            <TopbarLeftOnly>
                <TopbarCrumbActive title={translate('PotreeConverter.jobs')} icon="fa-flag-checkered" />
            </TopbarLeftOnly>
            <Content>
                <Tray>
                    <Panel>
                        {(isLoading && <Spinner />) || (
                            <PanelTable>
                                <TableHead>
                                    <TableHeadRow>
                                        <TableHeader>Type</TableHeader>
                                        <TableHeader>Submitted</TableHeader>
                                        <TableHeader>Started</TableHeader>
                                        <TableHeader>Payload</TableHeader>
                                        <TableHeader>Message</TableHeader>
                                        <TableHeader>&nbsp;</TableHeader>
                                    </TableHeadRow>
                                </TableHead>
                                <TableBody>
                                    {data &&
                                        data.map((item) => (
                                            <TableRow key={item.id}>
                                                <TableData>{item.jobType}</TableData>
                                                <TableData>{item.created_at}</TableData>
                                                <TableData>{item.startedOnDateTime}</TableData>
                                                <TableData>{JSON.stringify(item.payload, undefined, 2)}</TableData>
                                                <TableData>{item.message}</TableData>
                                                <TableData alignRight={true}>
                                                    <IconRemoveButton
                                                        removeQuestion={translate('common.confirmDeleteItem')}
                                                        onClick={async () => removeJob(item.id)}
                                                    />
                                                </TableData>
                                            </TableRow>
                                        ))}
                                </TableBody>
                            </PanelTable>
                        )}
                    </Panel>
                </Tray>
            </Content>
        </>
    );
}
